import React, { useContext, useEffect, useState } from 'react'
import QuestionComponent from './QuestionComponent';
import OptionsComponent from './OptionsComponent';
import {  firestore } from '../../../../firebase.config';
import { DataContext } from '../../../../Context/DataContext';

import { useScreenTransition } from '../../../../Hooks/useScreenTransition';

const options = [
    {
        value: "👤 1-5",
        icon: null,
    },
    {
        value: "👥 6-15",
        icon: null,
    } ,
    {
        value: "🧑‍🤝‍🧑 16-30",
        icon: null
    } ,
    {
        value: "🏢 31+",
        icon: null
    }  
]

const question =  {
    title: "3. Team Size",
    question: "Roughly how many team members would actively use eVerbary?",
    subQuestion: "Include anyone who manages, orders, or reviews translations",
    options: options,
}

const Ques3 = ({windowSize, currentScreen, setCurrentScreen, onContinue}) => {
    const [selectedOption, setSelectedOption] = useState(question.options[0].value);
    const {userData, teamData} = useContext(DataContext);

    const { transitionTo } = useScreenTransition();

    useEffect(() => {
        if(userData && userData.teamId && teamData){
          const onBoarding = teamData.onBoarding;
          if(!onBoarding || !onBoarding.translation_workflow){
            transitionTo(`/account/onboarding?step=1`);
            return;
          }
          if(!onBoarding || !onBoarding.immigration_platforms){
            transitionTo(`/account/onboarding?step=2`);
            return;
          }
          if(onBoarding && onBoarding.team_size){
            setSelectedOption(onBoarding.team_size);
          }
        }
      }, [userData, teamData])

    const onContinueQuestion = () => {
        const onBoarding = teamData.onBoarding;
        firestore.collection("teams").doc(userData.teamId).update(
          {
            onBoarding: onBoarding ? {...onBoarding, team_size: selectedOption} : {team_size: selectedOption}
          }).then(() => {
            onContinue();
          })
      }
  
      const onClickOption = (option) => {
        setSelectedOption(option.value);
      }

  return (
    <QuestionComponent
    windowSize={windowSize}
    question={question.question}
    onContinue={onContinueQuestion}
    progressTitle={question.title}
    progress={2}
    onBack={() => transitionTo(`/account/onboarding?step=${currentScreen - 1}`)}
    backBTnText="Back"
    disableContinue={!teamData || selectedOption === ""}
    subQuestion={question.subQuestion}
  >
    <div className={`flex gap-[8px] w-full flex-wrap max-sm:flex-col`}>
      {question.options.map((option, i) => <OptionsComponent className={"flex-[1]"} width={"w-full"} option={option} icon={option.icon}
      index={i}  selectedOption={selectedOption} onClickOption={onClickOption}/>)}
    </div>

  </QuestionComponent>
  )
}

export default Ques3;